// Used Google Tag Manager to track events, google tag manager is configured in main.tsx
// The following events is being triggered because GTM is listening to the events here posted
// Once you have a new tracking event, you can add it here and then create the event in GTM (Custom event)

import { IPlan } from "~/types/billing";
import { googleTagManagerKey } from "./environment";
import { getGclid } from "./analytics";

export function sendLPDataGoogleAds({
  email,
  name,
  phone,
}: {
  email: string;
  name: string;
  phone?: string;
}) {
  triggerGTMEvent({
    event: "contactFormSubmitted",
    LP_Data: {
      name: name || "",
      email: email || "",
      phone: phone || "",
    },
  });
}

export const triggerGTMEvent = (eventData: {
  event: string;
  event_category?: string;
  event_action?: string;
  event_label?: string;
  value?: string;
  [key: string]: any;
}) => {
  if (!googleTagManagerKey) {
    const { event, ...rest } = eventData;
    console.log(`[GTM Event - ${event}]`, rest);
    return;
  }

  // @ts-ignore
  if (window.dataLayer) {
    const gclid = getGclid();
    if (gclid) {
      eventData.gclid = gclid;
    }
    // @ts-ignore
    window.dataLayer.push(eventData);
  }
};

export type AxonEcommerceItem = {
  item_id: string;
  item_name: string;
  price: number;
  quantity: number;
  item_category?: string;
  item_variant?: string;
  item_brand?: string;
};

export type AxonEcommercePayload = {
  transaction_id?: string;
  currency?: string;
  value?: number;
  shipping?: number;
  tax?: number;
  items?: AxonEcommerceItem[];
};

// GA4-shape ecommerce push consumed by the Axon Pixel via GTM.
// Resets `ecommerce` before every push so GTM doesn't read stale items.
export const gtmPushEcommerce = (
  event:
    | "page_view"
    | "view_item"
    | "add_to_cart"
    | "begin_checkout"
    | "purchase",
  ecommerce: AxonEcommercePayload = {}
) => {
  if (typeof window === "undefined") return;
  // @ts-ignore
  window.dataLayer = window.dataLayer || [];
  // @ts-ignore
  window.dataLayer.push({ ecommerce: null });
  // @ts-ignore
  window.dataLayer.push({ event, ecommerce });
};

export function triggerGtagPurchaseEvent(plan: IPlan) {
  const eventBasedOnPlanKey = {
    "starter-monthly": "purchaseStarter",
    "pro-monthly": "purchaseProMonthly",
    "pro-yearly": "purchaseProYearly",
    "empire-monthly": "purchaseEmpireMonthly",
    "empire-yearly": "purchaseEmpireYearly",
    "unicorn-monthly": "purchaseUnicornMonthly",
    "unicorn-yearly": "purchaseUnicornYearly",
  };
  const planKey = `${plan.name.toLowerCase()}-${plan.interval}`;
  const event =
    eventBasedOnPlanKey[planKey as keyof typeof eventBasedOnPlanKey];
  try {
    // @ts-ignore
    triggerGTMEvent({ event });
  } catch (err) {
    console.log(err);
  }
}

export function triggerStartedTrialEvent() {
  console.log("starter trial");
  try {
    // @ts-ignore
    triggerGTMEvent({ event: "startedTrial" });
  } catch (err) {
    console.log(err);
  }
}

export function triggerSignupEvent() {
  try {
    // @ts-ignore

    triggerGTMEvent({ event: "userRegisterSuccess" });
  } catch (err) {
    console.log(err);
  }
}
